import { useLoadMore } from "@website/accommodation-ui/hotel-pagination/hotel-pagination.hook";
import { HotelPaginationPropertiesType } from "@website/accommodation-ui/hotel-pagination/hotel-pagination.types";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const LoadMore: FC<HotelPaginationPropertiesType> = (properties) => {
  const { reference } = useLoadMore(properties);
  return <div className="flex h-1 w-full justify-center" ref={reference} />;
};

const Component: FC<HotelPaginationPropertiesType> = (properties) => {
  const { children, loading } = properties;

  return (
    <div className="flex w-full flex-col gap-4">
      {children}
      {!loading && <LoadMore {...properties} />}
    </div>
  );
};

export const HotelPagination = memo(Component, deepCompare);
